import { useContext, useState } from "react";
import { useSelector } from "react-redux";

import { UserInfoBar } from "../../../../../../components/userInfoBar";
import { UserSettings } from "../../../../../../components/userSettings";
import { ReportButton } from "../../../../../../components/buttons/updait-btn";

import { UserNavbarWrapper } from "./styles";
import { NotificationsIcon } from "Icons/NotificationsIcon";
import Badge from "@mui/material/Badge";
import { DatasetValidationContext } from "providers/DatasetValidationProvider";
import { SOCKET_STATUS } from "constants/common.constants";

export const UserNavbar = () => {
  const { data } = useSelector((state) => state.userReducer);
  const [showSettings, setShowSettings] = useState(false);
  const { response, onOpenValidationScreen } = useContext(DatasetValidationContext);

  const showBadge = response && response.event === SOCKET_STATUS.READY_VALIDATION;

  return (
    <>
      <UserNavbarWrapper>
        <Badge
          badgeContent={showBadge ? 1 : 0}
          color="primary"
          onClick={() => {
            if (showBadge) onOpenValidationScreen(response?.dataset_id || null);
          }}
          sx={{ cursor: showBadge ? "pointer" : "default" }}
        >
          <NotificationsIcon animate={showBadge} animationType="swing" />
        </Badge>

        <ReportButton />
        <UserInfoBar
          setShowSettings={setShowSettings}
          first_name={data.first_name}
          last_name={data.last_name}
          role="Admin"
        />
      </UserNavbarWrapper>
      {showSettings && <UserSettings open={showSettings} onClose={setShowSettings} userData={data} />}
    </>
  );
};
